export default "/fonts/Poppins-Bold.ttf?cdb29a5d7ccf57ff05a3fd9216d11771";